export default {
  small: 'chart-small',
  medium: 'chart-medium',
  big: 'chart-big',
}